export const getAgeFromBirthday = (birthday: string): number => {
  const birthYear = Number.parseInt(birthday.slice(0, 4), 10);
  const currentYear = new Date().getFullYear();
  return currentYear - birthYear + 1;
};
